import { render, staticRenderFns } from "./ProductInfoWidget.vue?vue&type=template&id=97ad41dc&scoped=true&"
import script from "./ProductInfoWidget.vue?vue&type=script&lang=js&"
export * from "./ProductInfoWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ad41dc",
  null
  
)

export default component.exports